import {connect} from 'react-redux';
import QBEData from 'app/components/RightBarPane/Property/QBEData';

export const mapStateToProps = (state) => ({
    qbeData: state.getIn(['property', 'selectedProperty', 'qbeData']).toJS(),
});

export default connect(mapStateToProps, null)(QBEData);